import Vue from 'vue'
import service from '../services/notifications-service'

export function useNotifications() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getNotifications(params = {}) {
    state.loading = true
    try {
      const response = await service.getNotifications(params)
      state.items = response.current_page === 1
        ? [...response.data]
        : [...state.items, ...response.data]
      state.currentPage = response.current_page
      state.lastPage = response.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getNotifications }
}
